import { apiSlice } from "core/api";
import { makeCrudEndpoints } from "common/api/apiHelpers";
import { PronosticV2 } from "pronosticsv2/types/pronosticv2.model";

const api = apiSlice.injectEndpoints({
  endpoints: makeCrudEndpoints<"PronosticV2", PronosticV2>(
    "PronosticV2",
    "pronostics-v2",
  ),
});

export const {
  useGetPronosticV2Query,
  useListPronosticV2sQuery,
  useAddPronosticV2Mutation,
  useRemovePronosticV2Mutation,
  useUpdatePronosticV2Mutation,
} = api;
